var _radialGradient, _path, _g, _linearGradient, _linearGradient2, _path2, _path3, _linearGradient3, _radialGradient2, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwedenKenowX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 52.98,
    cy: 41.332,
    r: 58.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#31a3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#3fbef9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#54edf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#54edf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#52e8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858,
    stopColor: "#4cdae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#43c4c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937,
    stopColor: "#36a4a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967,
    stopColor: "#2a8883"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 1.32c26.73 0 48.38 21.8 48.38 48.68 0 26.89-21.66 48.68-48.38 48.68S1.62 76.89 1.62 50C1.62 23.12 23.28 1.32 50 1.32z",
    fill: "url(#a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#262e2f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.29 23.1 29.79-3.47 11.3 12.91 9.75-14.27 13.42-2.6-16.14 24.91 27.96 31.95-29.67 4.21-12.42-14.35-9.86 15.22-16.5 3.84 18.92-27.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73 43.08s-.24 9.97.98 15.48c1.24 5.51 3.88 8.67 4.62 8.74.74.06 2.95.37 4.06-.5 1.11-.86.43-1.92 1.72-1.54 1.29.37.68 1.43 3.32 1.05s3.76-1.49 3.76-1.49 2.65 1.12 5.42.18l5.79-1.98 40.23-4.77s2.31.46 5.23.13c2.92-.34 2.83-.59 3.11-1.08.28-.5.74-.78 1.17-.5s1.02 1.33 2.25.9c1.24-.44 4.4-1.43 4.71-1.89s1.89-9.42 2.08-14.4c.18-4.99-2.44-5.6-3.02-5.48-.59.12-6.41 1.36-10.78 1.85-4.37.5-8.65.34-8.65.34s-1.57-1.67-3.08-1.95-2-.28-2-.28-.89-1.52-3.2-1.14-7.27-.77-18.04 2.51c-10.78 3.29-14.99 7.44-14.99 7.44s-1.79-.9-4.46-.78c-2.68.13-4.74 2.05-4.74 2.05s.18-3.9-.25-4.8-1.1-.86-3.78-.74c-2.68.13-3.48.84-3.63 1.12l-.65 1.24s-.83.34-.92-.22c-.09-.55-.8-1.02-1.57-1.05-.76-.05-4.36-.49-4.69 1.56z"
  })))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 7.82,
    y1: 54.374,
    x2: 22.953,
    y2: 54.374
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2e4e3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M8.04 44.88c-.73 4.75.31 16.4 3.09 20.09 0 0 1.07.29 4.36-.2-1.51-2.47-2.78-6.23-3.04-8.62 2.02 2.61 3.85 5.64 6.11 8.03 3.11-.74 4.38-1.56 4.38-1.56l-7.51-9.42c.58-2.37 2.74-7.93 4.43-9.47 0 0-1.9-.15-5.26.15-1.44 2.34-2.45 6.39-2.81 7.74-.5-1.38-.59-3.92-.52-6.95l-3.23.21z",
    fill: "url(#b)",
    style: {
      fillRule: "evenodd"
    }
  }), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 19.501,
    y1: 58.453,
    x2: 32.148,
    y2: 52.687
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#e2e4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m25.56 56.58 7.76-.49s.12-7.25-5.11-8.74-7.82 2.48-8.31 6.07c-.5 3.6 2.71 8.43 5.85 9.29 3.14.87 5.6-.55 6.55-1.3.96-.74 1.44-1.64 1.44-1.64l-2.77-1.92s-1.04 1.89-3.26 1.49c-2.2-.41-2.15-2.76-2.15-2.76zm-1.04-2.79s3.57-.15 3.85-.25c.44-2.33-3.99-4.07-3.85.25z",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.54 61.29c.06 0 .11-.01.17-.01l4.94-.37c-.94-3.39-1.61-7.32-1.74-10.84l8.76 9.79 5.6-.37c-.94-6.88-1.77-13.7-2.28-20.38l-5.48.48c-.08 4.17.36 8.17 1.48 11.97l-8.62-10.91-4.88.77c-.46 6.54.47 13.18 2.05 19.87z",
    fill: "#fff"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 73.459,
    y1: 47.426,
    x2: 92.116,
    y2: 47.426
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#e2e4e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#d5d7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#bcbdbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#acadad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a7a7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M73.46 40.35c2.08 4.32 3.61 10.8 4.7 15.63 1.12-.02 2.74-.12 5-.39.38-3.13.56-6.33.76-9.47.98 1.34 1.73 6.96 1.85 9.12l4.08-.64c1.48-5.28 2.24-10.23 2.26-15.72-1.14.27-2.65.56-4.59.84.01 2.53.06 6.13-.46 8.45l-.74-8.29a87.92 87.92 0 0 1-4.89.46c.08 2.42-.01 4.92-.1 7.34 0 0-1.35-4.62-2.34-7.21-2.43.06-4.25-.01-5.53-.12z",
    fill: "url(#d)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 64.193,
    cy: 49.023,
    r: 11.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#e2e4e3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2 39.67c1.09 0 2.14.17 3.13.48.1-.82.27-1.98.66-2.02.59-.06 2.18.22 2.03.96s-.89.27-1.05 1.17l-.09.51a10.73 10.73 0 0 1 5.94 9.62c0 5.92-4.75 10.72-10.62 10.72s-10.62-4.8-10.62-10.72c0-3.5 1.66-6.61 4.24-8.56-.19-.1-.4-.18-.66-.23-.75-.17-.77-.15-.59-1.21.18-1.05.59-1.05 1.57-1.18.98-.12.7.5.68 1.21-.01.21.06.44.15.65.97-.55 2.04-.96 3.16-1.19l-.05-.86c-.01-.53-.46-.44-.95-.5-.5-.06-.19-.59-.13-1.14s1.94-.44 2.75-.41c.82.04.82.5.66.93-.15.44-.24.5-.8.5-.37 0-.27.77-.15 1.29.24-.01.49-.02.74-.02z",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.73 41.46c.66 2.14 3.37 13.02-1.51 12.42-4.89-.6.38-10.49 1.51-12.42zM25.14 14.12l5.05-.99s1.9-5.2 6.39-9.91l-4.43 1.52c-2.52 2.36-5.2 5.55-7.01 9.38zM57.67 1.93c1.2 2.28 1.8 6.08-7.5 6.02-10.86-.08-11.69-2.61-10.89-5.43 1.93-.44 3.9-.76 5.9-.96.29 1.92 1.1 4.12 3.34 4.39 3.27.4 3.83-2.1 3.66-4.58a46.81 46.81 0 0 1 5.49.56zm17.76 85.28s-1.77 3.21-4.82 6.85c-2.12 1-4.33 1.86-6.6 2.56 3.13-3.21 6.16-6.78 6.52-7.93.37-.2 3.11-.62 4.9-1.48zM42.39 98.08c-.22-.56-.28-1.17-.08-1.83.98-3.16 12.13-2.91 15.21-2.17 2.72.66 3.9 1.66 3.33 3.37a49.01 49.01 0 0 1-6.47 1.03c.15-.58.19-1.23 0-1.86-.55-1.86-6.77-1.98-6.46.86.04.43.13.81.22 1.16-1.95-.07-3.87-.26-5.75-.56z",
    fill: "#262e2f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwedenKenowX);
export default __webpack_public_path__ + "static/media/sweden_kenow_x.a1d3ba6dd7ae0f79f58fe6748a8007af.svg";
export { ForwardRef as ReactComponent };